import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";
import { CheckPermission } from "../Permissions/CheckPermissions";
import ScrollImage from "../../assets/images/chevron-up.svg"
import { FaPen , FaRegTrashAlt, FaPlus, FaBan , FaCloudUploadAlt} from "react-icons/fa";

const Permissions = (props) => {
  //   const sortOptions = [
  //     { id: 1, value: "admin", label: "Admin"},
  //     { id: 2, value: "all", label: "All" },
  //   ];
  const [sortOptions, setSortOptions] = useState([]);
  const [sortBy, setSortBy] = useState("all");
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [showsScrolBtn,setShowScrolBtn]= useState(false)

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getRole(token);
    getPermissions(token);
  }, []);

  useEffect(() => {
    const handleButtonVisibility=()=>{
      window.pageYOffset > 300 ? setShowScrolBtn(true) : setShowScrolBtn(false)
    }
    window.addEventListener("scroll",handleButtonVisibility)
    return(()=>{
      window.addEventListener("scroll",handleButtonVisibility)
    })

  },[]);

  const getPermissions = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          const sortedArray = _.sortBy(result, (x) => {
            return x.module_lable.toLowerCase();
          });
          const sortedArray2 = sortedArray?.sort((a, b) => {
            return a.role_name.localeCompare(b.role_name);
          });
          setData(sortedArray2);
        }
      })
      .catch((error) => console.log(" errror", error));
  };

  const getRole = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const sortOptions = result.map((item, index) => {
          return { value: item.name, label: item.name };
        });
        sortOptions.unshift({ value: "all", label: "all" });
        setSortOptions(sortOptions);
      })

      .catch((error) => console.log("error", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.id, token);
          setDelete(false);
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"User deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 202) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Permissions" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={4}>
                      <Button
                        className="btn btn-success waves-effect waves-light"
                        disabled={!CheckPermission("partnerrewards", "add")}
                        onClick={() => {
                          props?.history?.push("/add-permission");
                        }}
                      >
                        <FaPlus size={12} /> Assign Permissions
                      </Button>
                    </Col>
                    <Col md={8} className="d-flex justify-content-md-end">
                      <div style={{ marginRight: "50px" }}>
                        <input
                          style={{
                            border: "2px solid rgb(238, 238, 238)",
                            width: "290px",
                            height: "35px",
                          }}
                          className="form-control"
                          placeholder="Search By Module...."
                          type="text"
                          id="page_input"
                          onChange={(e) => {
                            // handleSearch(e.target.value);
                            setSearchQuery(e.target.value.toLowerCase());
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Role</label>

                        <select
                          name="cars"
                          id="cars"
                          defaultValue={sortBy}
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{
                            width: 150,
                            height: 35,
                            marginLeft: 10,
                            borderRadius: "2px",
                            color: "#706b6b",
                            border: "2px solid #EEEEEE",
                          }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {capitalizeFirstLetter(item.label)}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr style={{ background: "#EEEEEE" }}>
                          {/* <th>Page</th> */}
                          <th>Module</th>
                          {sortBy == "all" && (
                            <th style={{ width: "7%" }}>Role</th>
                          )}
                          <th style={{ width: "7%" }}>add</th>
                          <th style={{ width: "7%" }}>update</th>
                          <th style={{ width: "7%" }}>delete</th>
                          <th style={{ width: "7%" }}>view</th>
                          <th style={{ width: "7%" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 &&
                          data?.map((item, index) => {
                            if (item?.role_name != sortBy && sortBy != "all") {
                              return;
                            }
                            if (searchQuery) {
                              if (
                                !item?.module_lable
                                  .toLowerCase()
                                  .includes(searchQuery)
                              ) {
                                return;
                              }
                            }
                            return (
                              <tr key={index}>
                                <td style={{ background: "#EEEEEE" }}>
                                  {item?.module_lable}
                                </td>
                                {sortBy == "all" && (
                                  <td>
                                    {capitalizeFirstLetter(item?.role_name)}
                                  </td>
                                )}
                                <td>
                                  {item?.add == 1 ? (
                                    <span style={{ color: "#68cf18" }}>✔</span>
                                  ) : (
                                    <span style={{ color: "red" }}>✘</span>
                                  )}
                                </td>
                                <td>
                                  {item?.update == 1 ? (
                                    <span style={{ color: "#68cf18" }}>✔</span>
                                  ) : (
                                    <span style={{ color: "red" }}>✘</span>
                                  )}
                                </td>
                                <td>
                                  {item?.delete == 1 ? (
                                    <span style={{ color: "#68cf18" }}>✔</span>
                                  ) : (
                                    <span style={{ color: "red" }}>✘</span>
                                  )}
                                </td>
                                <td>
                                  {item?.view == 1 ? (
                                    <span style={{ color: "#68cf18" }}>✔</span>
                                  ) : (
                                    <span style={{ color: "red" }}>✘</span>
                                  )}
                                </td>
                                <td>
                                  <Row>
                                    <div className="d-flex justify-content-around">
                                      <div
                                        style={{
                                          width: 30,
                                          textAlign: "center",
                                        }}
                                        className="text-primary"
                                      >
                                        {item.role_name != "merchant" ? (
                                          <a
                                            className="font-size-18"
                                            onClick={() => {
                                              props?.history?.push(
                                                "/add-permission",
                                                {
                                                  edit: true,
                                                  item: item,
                                                }
                                              );
                                            }}
                                          ><FaPen /></a>
                                        ) : (
                                          <i className="font-size-16"><FaBan /></i>
                                        )}
                                      </div>

                                      <div style={{ width: 30 }}>
                                        {item.role_name != "merchant" ? (
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i
                                              className="font-size-18"
                                              onClick={() => {
                                                setItemForDelete(item);
                                                setDelete(true);
                                              }}
                                            ><FaRegTrashAlt /></i>
                                          </Link>
                                        ) : (
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i className="font-size-16"><FaBan /></i>
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </Row>
                                </td>
                              </tr>
                            );
                          })}
                    {showsScrolBtn && <div
                        id="scrolToTop"
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                          style={{
                            position: "fixed",
                            bottom: "60px", 
                            right: "60px",
                            color: "gray",
                            textAlign: "center",
                            cursor: "pointer",
                            fontSize: "4em",
                            lineHeight: 0,
                            textDecoration:"none",
                          }}
                        >
                          <img src={ScrollImage} alt="" 
                          style={{width: "40px",
                            background: "#34C38F",
                            borderRadius: "50%",
                            padding:"5px"}} />
                        </div>}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Permissions;
